<template>
    <div class='eventdates'>
        <div class="form__group form__group--1-col">
            <div class="form__item">
                <div class="eventdates__table-container">
                    <table class="eventdates__table">
                        <thead>
                        <tr>
                            <th>Date</th>
                            <th>Time</th>
                            <th>Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-if="occurrences.length" v-for="occurrence in occurrences">
                            <td>{{ occurrence.date }}</td>
                            <td>{{ occurrence.isAllDay ? `All Day`: `${occurrence.startTime} - ${occurrence.endTime}` }}</td>
                            <td>
                                <button class='eventdates__minimum-button' type='button' @click='remove(occurrence.id)'>Remove</button>
                            </td>
                        </tr>
                        <tr v-if="!occurrences.length">
                            <td colspan='3'>
                                <div class="eventdates__table-message">
                                    Please add event date(s) by fill the form below.
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="form__group form__group--2-col">
            <div class="form__item">
                <div class='basic-form-item'>
                    <div class='eventdates__fake-input-container'>
                        <input class='eventdates__fake-input' v-model="date" :class="datepickerClass"/>
                        <svg class='eventdates__fake-input-icon' width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                    d="M21.8235 7.78947H10.1765V8.42105C10.1765 8.76986 9.88677 9.05263 9.52941 9.05263C9.17205 9.05263 8.88235 8.76986 8.88235 8.42105V7.78947H6.94118C6.58418 7.78947 6.29412 8.0726 6.29412 8.42105V11.5789H25.7059V8.42105C25.7059 8.0726 25.4158 7.78947 25.0588 7.78947H23.1176V8.42105C23.1176 8.76986 22.8279 9.05263 22.4706 9.05263C22.1132 9.05263 21.8235 8.76986 21.8235 8.42105V7.78947ZM23.1176 6.52632H25.0588C26.1305 6.52632 27 7.37498 27 8.42105V26.1053C27 27.1513 26.1305 28 25.0588 28H6.94118C5.86946 28 5 27.1513 5 26.1053V8.42105C5 7.37498 5.86946 6.52632 6.94118 6.52632H8.88235V4.63158C8.88235 4.28277 9.17205 4 9.52941 4C9.88677 4 10.1765 4.28277 10.1765 4.63158V6.52632H21.8235V4.63158C21.8235 4.28277 22.1132 4 22.4706 4C22.8279 4 23.1176 4.28277 23.1176 4.63158V6.52632ZM25.7059 12.8421H6.29412V26.1053C6.29412 26.4537 6.58418 26.7368 6.94118 26.7368H25.0588C25.4158 26.7368 25.7059 26.4537 25.7059 26.1053V12.8421Z"
                                    fill="black"/>
                        </svg>
                    </div>
                    <label class='basic-form-item__label'>Event Date</label>
                    <span class='basic-form-item__required-indicator'>*</span>
                </div>
            </div>
            <div class="form__item">
                <div class='basic-form-item'>
                    <div class="eventdates__fake-input">
                        <input type="checkbox" v-model='isAllDay'>
                        <label>Yes</label>
                    </div>
                    <label class='basic-form-item__label'>Is All Day Event?</label>
                    <span class='basic-form-item__required-indicator'>*</span>
                </div>
            </div>
        </div>
        <div class="form__group form__group--3-col">
            <div class="form__item" v-show="!isAllDay">
                <div class='basic-form-item' :class="{'basic-form-item--has-error':!!timeError}">
                    <div class='eventdates__fake-input-container'>
                        <input class='eventdates__fake-input' v-model="startTime" :class="timepickerClass"/>
                        <svg class="eventdates__fake-input-icon" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                    d="M16.6809 27.9767C13.7703 28.1559 10.8914 27.296 8.56734 25.5531C6.24331 23.8103 4.62849 21.3002 4.01642 18.4793C3.99429 18.3757 3.99453 18.2686 4.01713 18.1651C4.03972 18.0616 4.08415 17.964 4.14751 17.8786C4.21088 17.7932 4.29175 17.7221 4.38483 17.6698C4.47791 17.6175 4.5811 17.5853 4.68765 17.5752H4.79278C4.97965 17.56 5.16559 17.6137 5.31486 17.726C5.46414 17.8382 5.56622 18.0011 5.6015 18.1832C6.10556 20.4894 7.38712 22.5574 9.23579 24.0479C11.0845 25.5384 13.3904 26.3628 15.775 26.3858C18.1597 26.4087 20.4814 25.6288 22.359 24.1742C24.2366 22.7195 25.5586 20.6765 26.1079 18.3805C26.6572 16.0845 26.4012 13.672 25.3819 11.5389C24.3626 9.40585 22.6406 7.67903 20.4986 6.6419C18.3565 5.60477 15.9218 5.31896 13.5939 5.8314C11.2661 6.34384 9.18346 7.62407 7.68798 9.46194C7.57029 9.61614 7.39712 9.71962 7.20439 9.7509C7.01166 9.78219 6.81415 9.73888 6.65283 9.62996L6.56387 9.57395C6.47809 9.51407 6.40578 9.43725 6.3515 9.34835C6.29721 9.25945 6.26212 9.16039 6.24845 9.05741C6.23477 8.95443 6.24281 8.84976 6.27204 8.75001C6.30127 8.65025 6.35107 8.55756 6.4183 8.47779C7.68207 6.92392 9.31732 5.70614 11.1762 4.93454C13.0351 4.16294 15.0591 3.86185 17.0652 4.05847C19.0712 4.25509 20.9961 4.94323 22.6659 6.06069C24.3357 7.17815 25.6976 8.6897 26.6287 10.4587C27.5597 12.2277 28.0305 14.1984 27.9985 16.1926C27.9664 18.1868 27.4326 20.1416 26.4452 21.8805C25.4578 23.6193 24.0479 25.0872 22.3431 26.1516C20.6383 27.216 18.6923 27.8433 16.6809 27.9767Z"
                                    fill="black"/>
                            <path
                                    d="M4.86557 15.3108H4.76043C4.65256 15.2983 4.54866 15.263 4.45573 15.2074C4.3628 15.1517 4.283 15.0771 4.22169 14.9884C4.16039 14.8997 4.11901 14.799 4.10034 14.6931C4.08167 14.5873 4.08614 14.4787 4.11346 14.3747V14.2227C4.13507 14.1223 4.17719 14.0275 4.23723 13.9439C4.29726 13.8602 4.37395 13.7897 4.46257 13.7365C4.55119 13.6833 4.64988 13.6485 4.75256 13.6345C4.85524 13.6204 4.95975 13.6272 5.05966 13.6546H5.16479C5.35181 13.7088 5.51064 13.832 5.60847 13.9988C5.70629 14.1656 5.73564 14.3631 5.69046 14.5507V14.6307C5.67199 14.829 5.57477 15.012 5.42013 15.1395C5.26549 15.267 5.06606 15.3286 4.86557 15.3108Z"
                                    fill="black"/>
                            <path
                                    d="M12.0146 18.8233C11.9521 18.7378 11.9074 18.6409 11.8829 18.5382C11.8585 18.4356 11.8548 18.3291 11.8721 18.225C11.8893 18.1209 11.9273 18.0212 11.9837 17.9316C12.04 17.8421 12.1138 17.7644 12.2006 17.7032L15.2009 15.5669V8.77383C15.2009 8.56163 15.2861 8.35811 15.4378 8.20806C15.5895 8.05801 15.7952 7.97371 16.0097 7.97371C16.2241 7.97371 16.4298 8.05801 16.5815 8.20806C16.7332 8.35811 16.8184 8.56163 16.8184 8.77383V16.383L13.1468 19.0074C13.0604 19.0692 12.9624 19.1134 12.8586 19.1377C12.7549 19.1619 12.6472 19.1655 12.542 19.1484C12.4368 19.1313 12.336 19.0938 12.2455 19.038C12.155 18.9822 12.0765 18.9093 12.0146 18.8233Z"
                                    fill="black"/>
                        </svg>
                    </div>
                    <label class='basic-form-item__label'>Start Time</label>
                    <span class='basic-form-item__required-indicator'>*</span>
                    <div class='basic-form-item__error' v-if="timeError">{{ timeError }}</div>
                </div>
            </div>
            <div class="form__item" v-show="!isAllDay">
                <div class='basic-form-item' :class="{'basic-form-item--has-error':!!timeError}">
                    <div class='eventdates__fake-input-container'>
                        <input class='eventdates__fake-input' v-model="endTime" :class="timepickerClass"/>
                        <svg class="eventdates__fake-input-icon" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                    d="M16.6809 27.9767C13.7703 28.1559 10.8914 27.296 8.56734 25.5531C6.24331 23.8103 4.62849 21.3002 4.01642 18.4793C3.99429 18.3757 3.99453 18.2686 4.01713 18.1651C4.03972 18.0616 4.08415 17.964 4.14751 17.8786C4.21088 17.7932 4.29175 17.7221 4.38483 17.6698C4.47791 17.6175 4.5811 17.5853 4.68765 17.5752H4.79278C4.97965 17.56 5.16559 17.6137 5.31486 17.726C5.46414 17.8382 5.56622 18.0011 5.6015 18.1832C6.10556 20.4894 7.38712 22.5574 9.23579 24.0479C11.0845 25.5384 13.3904 26.3628 15.775 26.3858C18.1597 26.4087 20.4814 25.6288 22.359 24.1742C24.2366 22.7195 25.5586 20.6765 26.1079 18.3805C26.6572 16.0845 26.4012 13.672 25.3819 11.5389C24.3626 9.40585 22.6406 7.67903 20.4986 6.6419C18.3565 5.60477 15.9218 5.31896 13.5939 5.8314C11.2661 6.34384 9.18346 7.62407 7.68798 9.46194C7.57029 9.61614 7.39712 9.71962 7.20439 9.7509C7.01166 9.78219 6.81415 9.73888 6.65283 9.62996L6.56387 9.57395C6.47809 9.51407 6.40578 9.43725 6.3515 9.34835C6.29721 9.25945 6.26212 9.16039 6.24845 9.05741C6.23477 8.95443 6.24281 8.84976 6.27204 8.75001C6.30127 8.65025 6.35107 8.55756 6.4183 8.47779C7.68207 6.92392 9.31732 5.70614 11.1762 4.93454C13.0351 4.16294 15.0591 3.86185 17.0652 4.05847C19.0712 4.25509 20.9961 4.94323 22.6659 6.06069C24.3357 7.17815 25.6976 8.6897 26.6287 10.4587C27.5597 12.2277 28.0305 14.1984 27.9985 16.1926C27.9664 18.1868 27.4326 20.1416 26.4452 21.8805C25.4578 23.6193 24.0479 25.0872 22.3431 26.1516C20.6383 27.216 18.6923 27.8433 16.6809 27.9767Z"
                                    fill="black"/>
                            <path
                                    d="M4.86557 15.3108H4.76043C4.65256 15.2983 4.54866 15.263 4.45573 15.2074C4.3628 15.1517 4.283 15.0771 4.22169 14.9884C4.16039 14.8997 4.11901 14.799 4.10034 14.6931C4.08167 14.5873 4.08614 14.4787 4.11346 14.3747V14.2227C4.13507 14.1223 4.17719 14.0275 4.23723 13.9439C4.29726 13.8602 4.37395 13.7897 4.46257 13.7365C4.55119 13.6833 4.64988 13.6485 4.75256 13.6345C4.85524 13.6204 4.95975 13.6272 5.05966 13.6546H5.16479C5.35181 13.7088 5.51064 13.832 5.60847 13.9988C5.70629 14.1656 5.73564 14.3631 5.69046 14.5507V14.6307C5.67199 14.829 5.57477 15.012 5.42013 15.1395C5.26549 15.267 5.06606 15.3286 4.86557 15.3108Z"
                                    fill="black"/>
                            <path
                                    d="M12.0146 18.8233C11.9521 18.7378 11.9074 18.6409 11.8829 18.5382C11.8585 18.4356 11.8548 18.3291 11.8721 18.225C11.8893 18.1209 11.9273 18.0212 11.9837 17.9316C12.04 17.8421 12.1138 17.7644 12.2006 17.7032L15.2009 15.5669V8.77383C15.2009 8.56163 15.2861 8.35811 15.4378 8.20806C15.5895 8.05801 15.7952 7.97371 16.0097 7.97371C16.2241 7.97371 16.4298 8.05801 16.5815 8.20806C16.7332 8.35811 16.8184 8.56163 16.8184 8.77383V16.383L13.1468 19.0074C13.0604 19.0692 12.9624 19.1134 12.8586 19.1377C12.7549 19.1619 12.6472 19.1655 12.542 19.1484C12.4368 19.1313 12.336 19.0938 12.2455 19.038C12.155 18.9822 12.0765 18.9093 12.0146 18.8233Z"
                                    fill="black"/>
                        </svg>
                    </div>
                    <label class='basic-form-item__label'>End Time</label>
                    <span class='basic-form-item__required-indicator'>*</span>
                    <div class='basic-form-item__error' v-if="timeError">{{ timeError }}</div>
                </div>
            </div>
            <div class="form__item">
                <div class='eventdates__fake-input-container'>
                    <button class="eventdates__fake-input eventdates__fake-input--button" type='button' @click="addEventDate" :disabled="!isReadyToAdd">Add Event Date</button>
                </div>
            </div>
        </div>
        <input type="hidden" :name="eventDatesHandle" :value="eventDatesValue">
    </div>
</template>

<script>
  import flatpickr from 'flatpickr';

  const ID = function() {
    // Math.random should be unique because of its seeding algorithm.
    // Convert it to base 36 (numbers + letters), and grab the first 9 characters
    // after the decimal.
    return '_' + Math.random().toString(36).substr(2, 9);
  };

  export default {
    name: "EventDates",
    data() {
      let occurrences = [];
      if (this.initialValueJson && JSON.parse(this.initialValueJson)) {
        occurrences = JSON.parse(this.initialValueJson).occurrences || [];
      }
      return {

        datepickerClass: ID(),
        timepickerClass: ID(),
        occurrences: occurrences,

        date: "",
        isAllDay: false,
        startTime: "",
        endTime: "",

      }
    },
    methods: {
      reset() {
        this.date = "";
      },
      addEventDate() {
        let occurrence = {
          id: ID(),
          date: this.date,
          isAllDay: this.isAllDay,
          startTime: this.startTime,
          endTime: this.endTime
        }
        this.occurrences.push(occurrence);
        this.reset();
      },
      remove(id) {
        this.occurrences.splice(this.occurrences.findIndex(o => o.id == id), 1);
      }
    },
    computed: {
      timeError() {
        if (this.startTime && this.endTime && this.startTime >= this.endTime) {
          return "Please enter a valid time range";
        }
        return null;
      },
      isReadyToAdd() {
        if (!this.date) {
          return false;
        }
        if (this.timeError) {
          return false;
        }
        if (!this.isAllDay && (!this.startTime || !this.endTime)) {
          return false;
        }
        return true;
      },
      eventDatesValue() {
        let eventOccurrences = this.occurrences.map(o => {
          let from = o.date, to = o.date;
          if (o.isAllDay) {
            from += " 00:00";
            to += " 23:59";
          } else {
            from += ` ${o.startTime}`;
            to += ` ${o.endTime}`;
          }
          return {
            ruleId: o.id,
            from,
            to
          }
        });
        let eventRules = this.occurrences.map(o => {
          return {
            rRule: "",
            exceptions: [],
            startTime: o.isAllDay ? null : o.startTime,
            endTime: o.isAllDay ? null : o.endTime,
            id: o.id,
            isAllDay: o.isAllDay
          }
        });
        let eventDates = {
          eventOccurrences,
          eventRules
        };
        return JSON.stringify(eventDates);
      }
    },
    props: {
      'eventDatesHandle': {
        default() {
          return 'eventDates';
        }
      },
      'initialValueJson': {
        default() {
          return null;
        }
      }
    },
    mounted() {
      // Init datepicker
      Array.prototype.forEach.call(document.querySelectorAll(`.${this.datepickerClass}`), e => flatpickr(e, {}));

      // Init timepicker
      Array.prototype.forEach.call(document.querySelectorAll(`.${this.timepickerClass}`), e => flatpickr(e, {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
      }));
    }
  }
</script>

<style scoped lang='scss'>
    .eventdates {
        &__table-container {
            padding: 0 1em;
            background: #E1E1E1;
        }

        &__table {

            border-collapse: collapse;

            th {
                text-align: left;
                padding: 1em 0;
                border-bottom: 1px solid #141414;
            }

            td {
                padding: 0.5em 0;
            }

        }

        &__table-message {
            padding: 2em;
            text-align: center;
        }

        &__fake-input-container {
            position: relative;
        }

        &__fake-input {
            border: 1px solid #141414;
            border-radius: 0.25em;
            background-color: #F4F4F4;
            padding: .9em 0.9em .9em 0.9em;
            font-size: 1em;
            width: 100%;

            &--button {
                display: inline-block;
                transition: all .5s;
                cursor: pointer;

                &:not(:disabled):hover, &:not(:disabled):focus {
                    color: #F4F4F4;
                    background-color: #141414;
                }

                &:disabled {
                    cursor: not-allowed;
                    color: lighten(#141414, 50%);
                    border-color: lighten(#141414, 50%);
                }
            }
        }

        &__fake-input-icon {
            position: absolute;
            right: 1em;
            top: 50%;
            display: inline-block;
            transform: translateY(-50%);
        }

        &__minimum-button {
            display: inline-block;
            border: 1px solid transparent;
            transition: all .5s;
            background: transparent;
            margin: 0 0.25em 0 0;
            padding: 0;

            &:hover, &:focus {
                border-bottom-color: #141414;
            }
        }
    }
</style>
